<template lang='pug'>
  div
    v-btn(v-if='installed' text @click='disconnectSlack' color='error') Disconnect Slack
    div(v-if='!installed')
      a(:href='addToSlackUrl')
        img(alt='Add to Slack'
          height='40'
          width='139'
          src='https://platform.slack-edge.com/img/add_to_slack.png'
          srcset='https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x')
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {createHelpers} from 'vuex-map-fields';
import Notifications from '../services/notification.service';
import SaveMixin from '../mixins/save.mixin';

// We're using the same getter and mutation types
// as we've used in the store above.
const {mapFields} = createHelpers({
  getterType: 'getAccountField',
  mutationType: 'updateAccountField'
});

export default {
  name: 'SlackConfig',
  mixins: [SaveMixin],
  computed: {
    installed() {
      return this.account && !!this.account.slackToken;
    },
    addToSlackUrl() {
      // eslint-disable-next-line max-len
      return `https://slack.com/oauth/v2/authorize?client_id=310348203879.326106309748&scope=channels:read,chat:write,chat:write.customize,chat:write.public,groups:read&redirect_uri=${process.env.VUE_APP_APP}/integrations/slack&state=${this.account.guid}`;
    },
    ...mapGetters({
      dirty: 'isAccountDirty',
      user: 'getUser',
      account: 'getAccount'
    }),
    ...mapFields({
      slackToken: 'account.slackToken'
    })
  },
  methods: {
    async disconnectSlack() {
      if (!(await Notifications.confirm('Disconnect', 'Are you sure you want to disconnect Slack?'))) return;
      this.slackToken = null;
    },
    async save() {
      try {
        await this.updateAccount();
        await this.refreshUser(); // so our stored user/account reflects reality
      } catch (e) {
        Notifications.errorToast('Error Saving Check Console For Details', {
          duration: 100000,
          retry: this.save
        });
        console.error(e);
      }
      console.log('save');
    },
    ...mapActions({
      refreshUser: 'refreshUser',
      updateAccount: 'updateAccount',
      getAccount: 'getAccount'
    }),
    ...mapMutations({clearDirty: 'clearAccountDirty'})
  },
  data() {
    return {
      showToken: false
    };
  }
};
</script>

<style scoped>

</style>
